import {createContext} from 'react';

export const ImagePositionContext = createContext({});